import { memo, ReactElement, useMemo } from 'react';
import { Button, Flex, Space, Tag, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined, UngroupOutlined, GroupOutlined } from '@ant-design/icons';

import productStyles from '../../products/styles.module.css';
import { TableHeaderTitleProps } from '../../products/interfaces';

const { Text } = Typography;

export const TableHeaderTitle = memo(
  ({
    columnKey,
    title,
    editAll,
    disableEditAllKeys,
    columnsErrorsCount,
    validationFeedback,
    handleChangeEditAll,
  }: TableHeaderTitleProps) => {
    const { t } = useTranslation();

    const ErrorsTag = useMemo((): ReactElement | null => {
      if (!validationFeedback) return null;

      const count = columnsErrorsCount[columnKey];

      return count ? (
        <Tag color="red" icon={<ExclamationCircleOutlined />}>
          {count}
        </Tag>
      ) : null;
    }, [columnsErrorsCount, columnKey, validationFeedback]);

    if (!columnKey || columnKey === 'actions') return <Text strong>{title}</Text>;

    return (
      <Flex justify="space-between" align="center" gap="middle">
        <Space>
          <Tooltip title={t(editAll ? 'global.labels.disableEditAllColumn' : 'global.labels.enableEditAllColumn')} placement="top">
            <Button
              type="text"
              icon={editAll ? <GroupOutlined className={productStyles.lockIcon} /> : <UngroupOutlined />}
              onClick={() => handleChangeEditAll(columnKey)}
              disabled={disableEditAllKeys.includes(columnKey)}
            />
          </Tooltip>
          <Text strong>{title}</Text>
        </Space>
        {ErrorsTag}
      </Flex>
    );
  },
);
